export default __webpack_public_path__ + "static/media/lc-m.137af596.svg";